import React from 'react'
import { IonLoading } from '@ionic/react'
import { useGetMe } from '../../../modules/me'
import { PasswordChange } from '../../organisms'

export const PagePasswordChange = () => {
  const { user } = useGetMe()
  return user ? <PasswordChange user={user} /> : <IonLoading isOpen={true} />
}
